export default __webpack_public_path__ + "static/media/jc-logo-white.78b01bc4.svg";